import { makeStyles } from '@material-ui/styles'
import Card from 'pf9-ui-components/built/elements/card/Card'
import CardBody from 'pf9-ui-components/built/elements/card/CardBody'
import CardHeader from 'pf9-ui-components/built/elements/card/CardHeader'
import React from 'react'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import ResourceUtilizationChart from './ResourceUtilizationChart'

interface Props {
  className?: string
  resources: ResourceSummary[]
}

interface ResourceSummary {
  name: string
  allocated: number
  capacity: number
  utilization: number | null
  utilizationPercentage: number | null
  unit: string
}

export default function ResourceCapacityAndUtilizationCard({
  resources,
  className = undefined,
}: Props) {
  const classes = useStyles({})

  return (
    <Card className={className} withCustomBody>
      <CardHeader className={classes.resourceCardHeader}>
        <Text variant="subtitle1">Capacity and Utilization</Text>
      </CardHeader>
      <CardBody>
        <div>
          <ResourceUtilizationChart resources={resources} />
        </div>
      </CardBody>
    </Card>
  )
}

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  resourceCardHeader: {
    borderBottom: 'none',
  },
}))
